import { locateNode, selectedRoots, canEditNode, isTextEditing } from './node-operations'

export function selectionContains (nodes, selected, id) {
  const entry = locateNode(nodes, id), ids = new Set(selected)
  return !!entry && (ids.has(id) || entry.ancestors.some(node => ids.has(node.index)))
}

// 分组使用子组件的绝对坐标；选中父子时只移动一次，锁定分组不拆开移动。
export function selectionMovePlan (nodes, selected, anchorId) {
  const roots = selectedRoots(nodes, selected), anchor = locateNode(nodes, anchorId)
  if (!anchor || !roots.some(entry => entry.node === anchor.node || anchor.ancestors.includes(entry.node))) return null
  if (roots.length === 1 && roots[0].node === anchor.node && !anchor.node.children) return null
  const owner = roots.find(entry => entry.node === anchor.node || anchor.ancestors.includes(entry.node))
  const movableRoots = roots.filter(canEditNode), entries = []
  if (movableRoots.includes(owner)) {
    const collect = node => {
      if (node.children) node.children.forEach(collect)
      else if (node.component) entries.push({ node, left: Number(node.left) || 0, top: Number(node.top) || 0,
        width: Number(node.component.width), height: Number(node.component.height) })
    }
    movableRoots.forEach(entry => collect(entry.node))
  }
  if (entries.some(entry => ![entry.left, entry.top, entry.width, entry.height].every(Number.isFinite) || entry.width <= 0 || entry.height <= 0)) entries.length = 0
  const left = Math.min(...entries.map(entry => entry.left)), top = Math.min(...entries.map(entry => entry.top))
  const right = Math.max(...entries.map(entry => entry.left + entry.width)), bottom = Math.max(...entries.map(entry => entry.top + entry.height))
  return { entries, roots: movableRoots, bounds: { left, top, width: right - left, height: bottom - top } }
}

export function selectionMoveDelta (plan, requested, canvas) {
  if (!plan.entries.length) return { x: 0, y: 0 }
  const bound = (value, position, size, extent) => {
    const limit = Number(canvas[extent]), start = plan.bounds[position], length = plan.bounds[size]
    if (!Number.isFinite(limit) || limit < 1) return value
    if (length > limit) return 0
    return Math.max(-start, Math.min(value, limit - start - length))
  }
  const x = bound(Number(requested.x) || 0, 'left', 'width', 'width')
  const y = bound(Number(requested.y) || 0, 'top', 'height', 'height')
  return { x, y }
}

// 表单、菜单和辅助线各自处理方向键，避免键盘操作误移动画布选区。
export function isSelectionMoveKey (event) {
  return !!event && !event.defaultPrevented && !event.isComposing && !event.ctrlKey && !event.metaKey && !event.altKey &&
    ['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(event.key) && !isTextEditing(event.target) &&
    !(event.target && event.target.closest && event.target.closest('button, a, [role="button"], [role="tab"], [role="slider"], [role="menu"], [role="menuitem"], [data-editor-guides]'))
}
